module.exports = __webpack_public_path__ + "img/gargoyle_hochmut.6a19ce82.png";